import api from '@/services/api/config';

const path = 'v1/infra/teilegruppe';

export default {
  get: () => api.get(path),
};
